import { useRef, useState } from "react";

export default function Appointment() {
  const form = useRef();
  const [status, setStatus] = useState("");

  const sendMail = (e) => {
    e.preventDefault();

    const formData = new FormData(form.current);
    const name = formData.get("user_name");
    const subject = formData.get("subject");
    const message = formData.get("message");

    // Hardcoded recipient email
    const mailtoLink = `mailto:saisuchithpest@gmail.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(`Hi,\n\n${message}\n\nRegards,\n${name}`)}`;

    // Trigger mail client
    window.location.href = mailtoLink;

    setStatus("Redirected to your email client!");
    form.current.reset(); // Clear the form
  };

  return (
    <div
      className="border-2 max-w-6xl mx-auto mt-16 p-6 sm:p-8 scroll-mt-32 shadow-2xl rounded-lg bg-white"
      id="appointment"
    >
      <h1 className="text-2xl sm:text-3xl text-center font-bold text-red-500 mb-6">
        Appointment
      </h1>

      <form ref={form} onSubmit={sendMail}>
        {/* Name Field */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
          <div className="flex flex-col">
            <label className="text-base sm:text-lg font-medium">
              Your Name
            </label>
            <input
              type="text"
              name="user_name"
              required
              className="border-2 w-full h-12 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
            />
          </div>

          {/* Recipient Email Display Only */}
          <div className="flex flex-col">
            <label className="text-base sm:text-lg font-medium">
              Recipient's Email
            </label>
            <input
              type="email"
              name="user_email"
              value="saisuchithpest@gmail.com"
              disabled
              className="border-2 w-full h-12 p-3 rounded-md bg-gray-100 text-gray-500"
            />
          </div>
        </div>

        {/* Subject Field */}
        <div className="flex flex-col mt-6">
          <label className="text-base sm:text-lg font-medium">Subject</label>
          <input
            type="text"
            name="subject"
            required
            className="border-2 w-full h-12 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
          />
        </div>

        {/* Message Field */}
        <div className="flex flex-col mt-6">
          <label className="text-base sm:text-lg font-medium">Message</label>
          <textarea
            name="message"
            required
            className="border-2 w-full h-52 sm:h-72 p-3 rounded-md resize-none focus:outline-none focus:ring-2 focus:ring-red-500"
          />
        </div>

        {/* Submit Button */}
        <div className="flex justify-center mt-6">
          <button
            type="submit"
            className="relative border rounded-l-full rounded-br-full px-6 py-3
                     bg-red-500 text-white font-bold overflow-hidden transition-all
                     duration-300 before:content-[''] before:absolute before:top-0 before:left-0
                     before:w-0 before:h-full before:bg-black before:transition-all
                     before:duration-500 before:ease-in-out hover:before:w-full hover:text-white"
          >
            <span className="relative z-10">Send Message</span>
          </button>
        </div>

        {/* Status Message */}
        {status && (
          <p className="text-center mt-4 text-green-600 font-medium">
            {status}
          </p>
        )}
      </form>
    </div>
  );
}

// Auto matic send the Mail to

// import { useRef, useState, useEffect } from "react";
// import emailjs from "@emailjs/browser";

// export default function Appointment() {
//   const form = useRef();
//   const [status, setStatus] = useState("");

//   useEffect(() => {
//     // For debugging (optional - remove before production)
//     console.log("EmailJS service ID:");
//   }, []);

//   const sendEmail = (e) => {
//     e.preventDefault();

//     emailjs
//       .sendForm(
//         process.env.REACT_APP_EMAILJS_SERVICE_ID,
//         process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
//         form.current,
//         process.env.REACT_APP_EMAILJS_PUBLIC_KEY
//       )
//       .then(
//         (result) => {
//           // console.log(result.text);
//           setStatus("Message sent successfully!");
//           form.current.reset();
//         },
//         (error) => {
//           // console.error("Failed to send email:", error.text);
//           setStatus("Failed to send message. Please try again later.");
//         }
//       );
//   };

//   return (
//     <div
//       className="border-2 max-w-6xl mx-auto mt-16 p-6 sm:p-8 scroll-mt-32 shadow-2xl rounded-lg bg-white"
//       id="appointment"
//     >
//       <h1 className="text-2xl sm:text-3xl text-center font-bold text-red-500 mb-6">
//         Appointment
//       </h1>

//       <form ref={form} onSubmit={sendEmail}>
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
//           <div className="flex flex-col">
//             <label className="text-base sm:text-lg font-medium">
//               Your Name
//             </label>
//             <input
//               type="text"
//               name="user_name"
//               required
//               className="border-2 w-full h-12 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
//             />
//           </div>
//           <div className="flex flex-col">
//             <label className="text-base sm:text-lg font-medium">
//               Recipient's Email
//             </label>
//             <input
//               type="email"
//               name="user_email"
//               required
//               placeholder="support@sspc.in"
//               className="border-2 w-full h-12 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
//             />
//           </div>
//         </div>

//         <div className="flex flex-col mt-6">
//           <label className="text-base sm:text-lg font-medium">Subject</label>
//           <input
//             type="text"
//             name="subject"
//             required
//             className="border-2 w-full h-12 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
//           />
//         </div>

//         <div className="flex flex-col mt-6">
//           <label className="text-base sm:text-lg font-medium">Message</label>
//           <textarea
//             name="message"
//             required
//             className="border-2 w-full h-52 sm:h-72 p-3 rounded-md resize-none focus:outline-none focus:ring-2 focus:ring-red-500"
//           />
//         </div>

//         <div className="flex justify-center mt-6">
//           <button
//             type="submit"
//             className="relative border rounded-l-full rounded-br-full px-6 py-3 bg-red-500 text-white font-bold overflow-hidden transition-all duration-300 before:content-[''] before:absolute before:top-0 before:left-0 before:w-0 before:h-full before:bg-black before:transition-all before:duration-500 before:ease-in-out hover:before:w-full hover:text-white"
//           >
//             <span className="relative z-10">Send Message</span>
//           </button>
//         </div>

//         {status && (
//           <p className="text-center mt-4 text-green-600 font-medium">
//             {status}
//           </p>
//         )}
//       </form>
//     </div>
//   );
// }
